import { useTranslation } from 'react-i18next';
import { ShipmentCalculator } from '@features/shipment';

export function ShipmentCalculatorPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-6">
      <header>
        <h1 className="text-2xl font-semibold">{t('shipment.calculator.title')}</h1>
        <p className="text-sm opacity-70">{t('shipment.calculator.subtitle')}</p>
      </header>
      <ShipmentCalculator />
    </div>
  );
}
